export const ListQueryKey = 'fxwithdraws';
export const DetailQueryKey = 'fxwithdraw';
export const Urls = {
  selectUrl: '/fxWithdraw/list',
  updateUrl: '/fxWithdraw/update',
  deleteUrl: '/fxWithdraw/delete',
  createUrl: '/fxWithdraw/create',
  detailUrl: '/fxWithdraw/info'
};